import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, PRICE_LABEL } from "@/lib/checkout";
import { CheckCircle2 } from "lucide-react";
import Logo from "@/components/Logo";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ loading: true, paid: false, polls: 0 });

  useEffect(() => {
    if (!sessionId) {
      setStatus({ loading: false, paid: false, polls: 0 });
      return;
    }
    let cancelled = false;
    let polls = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        polls += 1;
        if (!cancelled) {
          if (data.payment_status === "paid") {
            setStatus({ loading: false, paid: true, polls });
          } else if (polls >= 10) {
            setStatus({ loading: false, paid: false, polls });
          } else {
            setStatus((s) => ({ ...s, loading: true, polls }));
            setTimeout(poll, 2000);
          }
        }
      } catch (e) {
        if (!cancelled) setStatus({ loading: false, paid: false, polls });
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-5 grain">
      <div className="max-w-xl w-full border border-white/10 bg-[#0a0a0a] p-10 relative">
        <div className="absolute top-5 right-5 font-mono text-[9px] tracking-[0.3em] text-red-500">
          STATUS · PAGAMENTO
        </div>
        <Logo className="h-8 w-8" />
        <div className="mt-10">
          {status.loading ? (
            <>
              <div className="font-display text-3xl text-neutral-50">Processando…</div>
              <p className="mt-3 text-neutral-500 text-sm">Aguardando confirmação do Stripe.</p>
            </>
          ) : status.paid ? (
            <>
              <CheckCircle2 className="h-10 w-10 text-red-500 mb-5" />
              <div className="font-display text-4xl text-neutral-50 leading-tight">
                Pagamento confirmado
              </div>
              <p className="mt-4 text-neutral-400">
                Enviaremos o PDF do dossiê para o e-mail cadastrado em instantes. Valor pago: {PRICE_LABEL}.
              </p>
            </>
          ) : (
            <>
              <div className="font-display text-3xl text-neutral-50">Pagamento não confirmado</div>
              <p className="mt-3 text-neutral-500 text-sm">
                Se você completou a transação, aguarde alguns minutos ou verifique seu e-mail.
              </p>
            </>
          )}
        </div>
        <Link
          to="/"
          className="inline-block mt-10 font-mono text-[11px] tracking-[0.3em] uppercase text-red-500 hover:text-red-400"
        >
          ← Voltar ao dossiê
        </Link>
      </div>
    </div>
  );
}
